import {SET_CONNECTION_STATUS} from 'constants/action-types.js';
import {SET_CONNECTED_USER_NAME} from 'constants/action-types.js';
import {SET_CLOCK_TICK} from 'constants/action-types.js';
import {SET_PLAY_SCHEDULED} from 'constants/action-types.js';
import {SET_AVAILABLE_USERS_TO_SYNC} from 'constants/action-types.js';
import {NONE} from 'constants/connection-status-types.js';

let initialState = {
    connectionStatus: NONE,
    connectedUserName: undefined,
    clockTick: undefined,
    playScheduled: false,
    availableUsers: [],
};

const clockReducer = (state = initialState, action) => {
    switch (action.type) {
    case SET_CONNECTION_STATUS:
        return {... state,
                connectionStatus: action.payload
        };
    case SET_CONNECTED_USER_NAME:
        return {... state,
                connectedUserName: action.payload
        };
    case SET_CLOCK_TICK:
        return {... state,
                clockTick: action.payload
        };
    case SET_PLAY_SCHEDULED:
        return {
            ... state,
            playScheduled: action.payload
        };
    case SET_AVAILABLE_USERS_TO_SYNC:
        console.log('setting available users = ');
        console.log(action.payload);
        return {
            ... state,
            availableUsers: action.payload
        };
    default:
        return state;
    }
}

export default clockReducer;
 
